import { IconCalendar } from "@studyplus/boron-ui";
import classNames from "classnames";
import { DateRange } from "../../general/DynamicDateRangePicker";
import Icon from "../Icon";
import { Dates } from "./Dates";
import styles from "./styles.scss";

type Props = {
  dateRange: DateRange;
  placeholder: string;
  isFocused: boolean;
  onClick: () => void;
  onClear: () => void;
  className?: string;
  hasError?: boolean;
};

// カレンダーの表示/非表示切り替え, 選択中の日付を表示する部分
export const Controller = ({
  dateRange,
  placeholder,
  isFocused,
  onClick,
  onClear,
  className,
  hasError = false,
}: Props) => {
  const { startDate, endDate } = dateRange;

  const handleClearClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClear();
  };

  return (
    <div
      className={classNames(styles.controller, className, {
        [styles.muted]: !startDate && !endDate,
        "border-blue-400": isFocused,
        "border-red-400": hasError,
      })}
      onClick={onClick}
    >
      <IconCalendar
        className={classNames("mr-4 h-2 w-2", {
          "text-gray-600": !isFocused,
          "text-blue-400": isFocused,
        })}
      />
      <div className="flex-1">
        <Dates dateRange={dateRange} placeholder={placeholder} />
      </div>
      {(startDate || endDate) && (
        <button
          type="button"
          onClick={handleClearClick}
          className="ml-2 p-1 hover:bg-gray-100 rounded flex items-center justify-center border-none bg-transparent cursor-pointer transition-colors"
        >
          <Icon name="icon-close-x" className="h-2 w-2 text-gray-600" />
        </button>
      )}
    </div>
  );
};
